import Vue from 'vue';
import VueSwal from 'vue-swal/dist/vue-swal.common.js';

Vue.use(VueSwal);
